// extracted by mini-css-extract-plugin
export default {"arrowAnimation":"tQZfWy","icon":"ZuBQsa","arrowIcon":"tplEGo","moveInAndShow":"N6cS_J","buttonContent":"M6YGFd","moveIn":"wLQPPU","moveOut":"WmcrX6","moveOutAndHide":"Bkw8Pv"};